export default "https://assets.egbcdn.net/assets/packs/_/videos/lootbox/video-csgo-22aa4b5413695914c594620c3733dc0c.ogv";